import { render, staticRenderFns } from "./afAccount.vue?vue&type=template&id=2e551a48"
import script from "./afAccount.vue?vue&type=script&lang=js"
export * from "./afAccount.vue?vue&type=script&lang=js"
import style0 from "./afAccount.vue?vue&type=style&index=0&id=2e551a48&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports